<unified-ui-loader [isLoading]="isLoading"></unified-ui-loader>
<div class="periods flex flex-column gap-1 flex-1">
    @if (!hideGranularity()) {
    <div class="flex flex-row gap-4 align-items-baseline p-2">
        <label class="flex gap-1"> Calendar Type<span class="text-red-500">*</span> </label>
        <p-select
            [options]="(calendarDataOptionList$() | async)! || []"
            optionLabel="displayName"
            [ngModel]="selectedCalendarType$() | async"
            [placeholder]="'Select Calendar'"
            [emptyMessage]="'No data found'"
            [required]="true"
            [disabled]="isLoading"
            styleClass="period-selector flex flex-1"
            (onChange)="setCalendarType($event.value)">
        </p-select>
        <label class="flex gap-1"> Granularity Selection<span class="text-red-500">*</span> </label>
        <p-select
            [options]="granularityList"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedGranularity$() | async"
            [placeholder]="'Select Periods'"
            [emptyMessage]="'No data found'"
            [required]="true"
            [disabled]="isLoading || !(selectedCalendarType$() | async)"
            [dataKey]="'key'"
            styleClass="period-selector flex flex-1"
            (onChange)="changeGranularity($event.value)">
        </p-select>
        @if ((selectedGranularity$() | async) && (selectedGranularity$() | async) !== periodAggregationEnum.Year &&
        enableQuarterFormat()) {
        <label class="flex gap-1"> Format<span class="text-red-500">*</span> </label>
        <p-select
            [options]="quarterFormatList"
            optionLabel="label"
            optionValue="value"
            [ngModel]="selectedQuarter$() | async"
            [placeholder]="'Select Quarter Format'"
            [emptyMessage]="'No data found'"
            [required]="true"
            [disabled]="isLoading"
            [dataKey]="'key'"
            styleClass="period-selector flex flex-1"
            (onChange)="changeQuarterFormat($event.value)">
            <!-- || !(selectedQuarterFormat$ | async) -->
        </p-select>
        }
    </div>
    }
    <p-tree
        #tree
        class="unified-p-tree p-tree-with-inverse-selection"
        selectionMode="checkbox"
        [value]="activeCalendarTree()"
        [filter]="true"
        [selection]="selectedCalendars$() | async"
        (onNodeSelect)="setCalendarsSelection(tree.selection)"
        (onNodeUnselect)="setCalendarsSelection(tree.selection)"
        [filterPlaceholder]="'Filter years, quarters, months, and weeks...'"
        scrollHeight="flex"
        [trackBy]="treeTrackBy">
        <ng-template pTemplate="filtericon"><i class="pi pi-filter"></i></ng-template>
        <ng-template pTemplate="header">
            <div class="p-tree-header flex justify-content-between">
                <p-checkbox
                    inputId="selectAllCheckbox"
                    [binary]="true"
                    [disabled]="activeCalendarTree().length === 0"
                    [ngModel]="isAllSelected()"
                    (onChange)="selectAll(tree, !!$event.checked)"
                    pTooltip="Select/Deselect All"
                    tooltipPosition="right">
                </p-checkbox>
                <button
                    pButton
                    type="button"
                    class="unified-flat-button"
                    (click)="selectInverse(tree)"
                    [disabled]="(selectedCalendars$() | async)?.length === 0"
                    pTooltip="Selects the opposite of the current selection"
                    tooltipPosition="top">
                    <i class="g-inverse"></i>
                    <span>Select Inverse</span>
                </button>
            </div>
        </ng-template>
    </p-tree>
</div>